import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    standalone: false
})
export class TitleComponent implements OnInit {
  @Input() title: string;
  @Input() label: string;

  constructor() {}

  ngOnInit() {}
}
